/**
 * Analysis page sector GHG chart colors (leaf module — no imports from navChartPalette).
 * Avoids circular-import races where ANALYSIS_SECTOR_GHG_PALETTE is undefined at module init.
 */

const HEX = /^#?([0-9a-fA-F]{6})$/;

function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const m = hex.trim().match(HEX);
  if (!m) return { r: 0, g: 0, b: 0 };
  const n = parseInt(m[1], 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

function navStack(hex: string, fillAlpha: number): { border: string; fill: string } {
  const { r, g, b } = hexToRgb(hex);
  return {
    border: `rgb(${r}, ${g}, ${b})`,
    fill: `rgba(${r}, ${g}, ${b}, ${fillAlpha})`,
  };
}

function navStackDual(hex: string, borderAlpha: number, fillAlpha: number): { border: string; fill: string } {
  const { r, g, b } = hexToRgb(hex);
  return {
    border: `rgba(${r}, ${g}, ${b}, ${borderAlpha})`,
    fill: `rgba(${r}, ${g}, ${b}, ${fillAlpha})`,
  };
}

const GHG_SECTOR_HEX = {
  transportBlue: '#003262',
  buildingNaturalGasGreen: '#15803d',
  buildingElectricityOrange: '#f59e0b',
  agricultureGreen: '#006B5B',
  wastePink: '#ED4E33',
  offroadTeal: '#3B7EA1',
  industrialBlueGray: '#63666A',
  highGwpPurple: '#4A3D7A',
} as const;

export const ANALYSIS_SECTOR_GHG_PALETTE = {
  transportation: navStack(GHG_SECTOR_HEX.transportBlue, 1),
  naturalGas: navStack(GHG_SECTOR_HEX.buildingNaturalGasGreen, 1),
  electricity: navStack(GHG_SECTOR_HEX.buildingElectricityOrange, 1),
  agriculture: navStack(GHG_SECTOR_HEX.agricultureGreen, 1),
  waste: navStackDual(GHG_SECTOR_HEX.wastePink, 1, 0.9),
  offroad: navStackDual(GHG_SECTOR_HEX.offroadTeal, 1, 0.9),
  industrial: navStackDual(GHG_SECTOR_HEX.industrialBlueGray, 1, 0.6),
  highGwp: navStackDual(GHG_SECTOR_HEX.highGwpPurple, 1, 0.5),
  undeterminedElectricity: navStackDual(GHG_SECTOR_HEX.buildingElectricityOrange, 1, 0.4),
  wasteCarb: navStack(GHG_SECTOR_HEX.wastePink, 1),
  industrialCarb: navStack(GHG_SECTOR_HEX.industrialBlueGray, 1),
  highGwpCarb: navStack(GHG_SECTOR_HEX.highGwpPurple, 1),
} as const;
